import { React, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import useToken from '../../util/useToken';

import { getImages } from '../../util/api';
import { addImage } from '../../util/api';
import { updateImage } from '../../util/api';
import { deleteImage } from '../../util/api';

import { getFilterOptions } from '../../util/api';
import NumberInput from '../NumberInput';
import DateTimeInput from '../DateTimeInput';
import DropDownInput from '../DropDownInput';
import TextInput from '../TextInput';
import PrimerPairInput from '../inputs/PrimerPairInput';
import Sanger from '../sanger/Sanger';

import { format } from 'date-fns';

import AddImage from '../addImage/AddImage';

import './ImageAnalysis.css'
import { setRef } from '@material-ui/core';

export default function ImageAnalysis ( { sampleID } ) {
    const [ loading, setLoading ] = useState(true);
    const loadingGIF = require('../../content/loading.gif');
    const { token, setToken, removeToken, validToken} = useToken();
    const [ firstLoad, setFirstLoad ] = useState(true);
    const [ imageAnalysis, setImageAnalysis ] = useState({"results":[]});
    const [ editMode, setEditMode ] = useState(false);
    const [ viewMode, setViewMode ] = useState(false);
    const [ selectedId, setSelectedId ] = useState(null);
    const [ refresh, setRefresh ] = useState(false);
    const [ viewingSanger, setViewingSanger ] = useState(false);
    const [ addImageOpen, setAddImageOpen ] = useState(false);

    //Pagination variables
    const [ page, setPage ] = useState(1)
    const [ editedPage, setEditedPage] = useState(1);
    const [ pageSize, setPageSize ] = useState(5)
    const [ editedPageSize, setEditedPageSize ] = useState(5);
    const [ resultCount, setResultCount ] = useState(0);

    const [options, setOptions] = useState({"windDirections":[], "conditions":[], "species":[], "siteMarshes":[], "storageBuffers":[], "sites":[], "imageTypes":[]});
    
    const [ currentObject, setCurrentObject ] = useState({});

    const handleCheckboxChange = (event, id) => {
        if(id === selectedId){
            setSelectedId(null)
        }else{
            setSelectedId(id);
        }
    };

    useEffect(() => {
        getImages(token, sampleID, page, pageSize).then(response => {
            response.json().then(json => {
                if(response.status !== 200){
                    alert(json["message"])
                }else{
                    setImageAnalysis(json)
                    setResultCount(json["resultCount"])
                }
            })
            setRefresh(false)
            setLoading(false)
        })

    }, [refresh, page, pageSize])

    const handleInputChange = (event, name) => {
        if(name === "imageType"){
            let object = JSON.parse(event.target.value)
            setCurrentObject({
                ...currentObject,
                [name+"ID"]: object.id,
                [name]: object,
            });
        }else{
            setCurrentObject({
                ...currentObject,
                [name]: event.target.value,
            });
        }
        const updatedInformation = {
            ...imageAnalysis,
            results: imageAnalysis.results.map(item => {
                if (item.id === editMode) {
                    if(name === "primerPair"){
                        let object = JSON.parse(event.target.value)
                        return{
                            ...item,
                            [name+"ID"]: object.id,
                            [name]: object,
                        }
                    }else{
                        return {
                            ...item,
                            [name]: event.target.value
                        };
                    }
                }
                return item;
            })
        };
    
        setImageAnalysis(updatedInformation);

    };


    useEffect(() => {
        const fetchOptions = async () => {
            let options = await getFilterOptions(token);
            setOptions(options)
        }
        fetchOptions();
    }, []);


    const deleteImageAnalysisRow = () => {
        deleteImage(token, selectedId, sampleID).then(response => {
            response.json().then(json => {
                if(response.status !== 200){
                    alert(json["message"])
                }else{
                    setRefresh(true)
                    setSelectedId(null)
                }
            })
        })
    }
    
    const addImageAnalysisRow = () => {
        setCurrentObject({"id":-1, "sampleID":sampleID})
        setEditMode(true)
        setViewMode(true)
        setSelectedId(-1)
    }

    const handleOnClickEditOrSave = () => {
        if(editMode == true){
            if(currentObject["id"] !== -1){
                updateImage(token, currentObject).then(response => {
                    response.json().then(json => {
                        if(response.status !== 200){
                            alert(json["message"])
                        }else{
                            setRefresh(true)
                            setEditMode(false)
                        }
                    })
                })
            }else{
                addImage(token, currentObject).then(response => {
                    response.json().then(json => {
                        if(response.status !== 200){
                            alert(json["message"])
                        }else{
                            setRefresh(true)
                            setEditMode(false)
                        }
                    })
                })
            }
        }else{
            setEditMode(true)
        }
    }


    const handleFowardClick = () => {
        if(page < (resultCount / pageSize)){
            setPage(page + 1)
        }
    }

    const handleBackClick = () => {
        if(page > 1){
            setPage(page - 1)
        }
    }
    
    return(
        <div className="container">
            {(loading || refresh) && 
                <div className="loading-position">
                    <img src={loadingGIF}></img>
                </div>
            }
            {!viewMode &&
            <div className="image-table-container">
                {addImageOpen && <AddImage sampleID={sampleID} open={addImageOpen} setOpen={setAddImageOpen} setRefresh={setRefresh}/>}
                <div className="image-table-buttons">
                    <div>
                        <button disabled={!selectedId} onClick={() => {setViewMode(true); setCurrentObject(imageAnalysis?.results.find(item => item.id === selectedId))}}>View</button>
                        <button onClick={() => {addImageAnalysisRow()}}>Add</button>
                        <button className="image-table-large-button" onClick={() => {setAddImageOpen(true)}}>Add Existing</button>
                        <button disabled={!selectedId} onClick={() => {deleteImageAnalysisRow()}}>Delete</button>
                    </div>
                    <div>
                        <button onClick={() => {handleBackClick()}}>{"<"}</button>
                        <input
                            className="page-input"
                            type="number"
                            value={editedPage}
                            onChange={(event) => {setEditedPage(event.target.valueAsNumber || editedPage)}}
                            onBlur={(event) => {
                                const enteredPage = event.target.valueAsNumber || editedPage;
                                const maxPage = Math.ceil(resultCount / pageSize);
                                setPage(Math.max(1, Math.min(enteredPage, maxPage)));
                                setEditedPage(Math.max(1, Math.min(enteredPage, maxPage)));
                              }}
                        />          
                        <button onClick={() => {handleFowardClick()}}>{">"}</button>
                        <input
                            className="page-input"
                            type="number"
                            value={editedPageSize}
                            onChange={(event) => {setEditedPageSize(event.target.valueAsNumber || editedPageSize)}}
                            onBlur={(event) => {
                                setPageSize(editedPageSize);
                            }}
                        />
                    </div>
                </div>
                <table className="image-table">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Type</th>
                            <th>Link</th>
                        </tr>
                    </thead>
                    <tbody>
                        {imageAnalysis?.results.length > 0 && imageAnalysis?.results?.map((result) => (
                            <tr key={result.id}>
                                <td>
                                    <input
                                        type="checkbox"
                                        checked={selectedId === result.id}
                                        onChange={event => handleCheckboxChange(event, result.id)}
                                    />
                                </td>
                                <td>{result.imageType?.value}</td>
                                <td>{result.imageLink}</td>
                            </tr>
                        ))}
                        {imageAnalysis?.results.length == 0 &&
                            <tr>
                                <td colSpan="6" style={{ textAlign: 'center' }}>
                                    <p>No Results</p>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
                {resultCount !== 0 ? <p>{page}/{Math.ceil(resultCount/pageSize)}</p> : <p></p>}
            </div>   
            }
            {viewMode && selectedId &&
                <div>
                    <button onClick={() => {setViewMode(false); setEditMode(false); setRefresh(true);}}>Back</button>
                    <button onClick={() => {handleOnClickEditOrSave()}}>{editMode ? "Save" : "Edit"}</button>
                    <div className="information-container">
                        <div>
                            <TextInput
                                label="Link"
                                value={currentObject["imageLink"]} 
                                onChange={(event) => {handleInputChange(event, "imageLink")}}
                                editable={editMode}
                            />
                            <DropDownInput
                                label="Type"
                                value={currentObject["imageType"]} 
                                options={options["imageTypes"]}
                                onChange={(event) => {handleInputChange(event, "imageType")}}
                                editable={editMode}
                            />
                            <TextInput
                                label="Note"
                                value={currentObject["note"]} 
                                onChange={(event) => {handleInputChange(event, "note")}}
                                editable={editMode}
                            />
                        </div>                              
                    </div>
                </div>
            }
        </div>
    );

  }